<template>
  <div class="previousOrders">
    <div class="title-box clearfix">
      <el-form inline ref="previousOrdersForm" v-model="previousOrdersForm" class="right themed-form search-form" style="line-height: 40px;">
          <el-form-item>
              <el-input v-model="previousOrdersForm.orderNumber" placeholder="订单号" class="iccid-width"></el-input>
          </el-form-item>
          <el-form-item>
              <el-input v-model="previousOrdersForm.iccidMark" placeholder="ICCID" class="iccid-width"></el-input>
          </el-form-item>
          <el-form-item>
              <el-input v-model="previousOrdersForm.shortIccid" placeholder="短号" class="iccid-width"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" class="themed-button" @click="onSearch">查询</el-button>
          </el-form-item>
        </el-form>
    </div>
    <el-table :data="tableData" ref='table' stripe border :max-height="maxTableHeight">
      <el-table-column prop="orderNumber" label="订单号" show-overflow-tooltip min-width="150"> </el-table-column>

      <el-table-column prop="iccidMark" label="ICCID" show-overflow-tooltip min-width="150"> </el-table-column>
      <el-table-column prop="shortIccid" label="短号" show-overflow-tooltip min-width="120"/>
      <el-table-column prop="mealName" label="套餐名称"> </el-table-column>

      <el-table-column prop="mealTypeStr" label="套餐类型"> </el-table-column>

      <el-table-column prop="type" label="订单类型">
          <template slot-scope="scope">
              <span v-if="scope.row.type === 1">微信订单</span>
              <span v-else-if="scope.row.type === 2">后台订单</span>
              <span v-else-if="scope.row.type === 3">代理商订单</span>
          </template>
      </el-table-column>

      <el-table-column prop="flowSize" label="套餐流量"> </el-table-column>

      <el-table-column prop="effectType" label="次月生效">
          <template slot-scope="scope">
            <span v-if="scope.row.mealType==2&&(scope.row.mealType==10||scope.row.mealType==12)">是</span>
            <span v-else>否</span>
          </template>
      </el-table-column>

      <el-table-column prop="remark" label="备注">
          <template slot-scope="scope">
              <el-input v-model="scope.row.remark" @change="(value)=>{addRemark(value,scope.row)}"></el-input>
          </template>
      </el-table-column>

      <el-table-column prop="createTime" label="订购时间" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="orderMoney" label="订单金额" show-overflow-tooltip> </el-table-column>
      <el-table-column prop="rebateMoney" label="拼单返现金额" min-width='150' show-overflow-tooltip v-if="isCaptal!='1'"> </el-table-column>
      <el-table-column label="操作">
              <template slot-scope="scope">
                  <el-button type="primary" class="themed-button" @click="handleTuiKuan(scope.row.orderNumber,scope.row.orderMoney)">登记退款</el-button>
              </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[5, 10, 15, 50,100,1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
    

    <el-dialog title="退款" :visible.sync="dialogRefundVisible" :destroy-on-close='true'>
        <el-form :model="refundForm" :rules="rules">
            <el-form-item label="金额" prop="returnMoney">
            <!-- <el-input v-model="refundForm.returnMoney" type="number" autocomplete="off"  maxlength="8" style="width:200px"></el-input> -->
            <el-input-number  v-model="refundForm.returnMoney" :min="0" :step="1" :max="999999" style="width:200px"/>
            </el-form-item>
            <el-form-item label="退款理由" prop="returnReson">
            <el-input type="textarea" v-model="refundForm.returnReson" show-word-limit maxlength="255"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button class="themed-button" type="info" @click="dialogRefundVisible = false">取 消</el-button>
            <el-button class="themed-button" type="primary" @click="sureRefund" v-preventReClick='1000' :disabled="isDisable">确 定</el-button>
        </div>
        </el-dialog>
    
  </div>
</template>

<script type="text/ecmascript-6">
import { orderRecord,add4remark,refundMoney } from "@/api/cardManagement/cardBillDetail.js";
// import resize from '@/mixins/resize.js'
import {mapGetters} from 'vuex'

export default {
  // mixins:[resize],
  data() {
    return {
        pageNo:1,
        pageSize:15,
        total:0,
        tableData:[],
        //iccidMark:'',
        dialogRefundVisible:false,
        orderMoney:'',
        refundForm:{
          orderNumber:'',
          returnMoney:'',
          returnReson:'',
        },
        maxTableHeight:null,
        isDisable:false,
        previousOrdersForm:{
          orderNumber:'',
          iccidMark:'',
          shortIccid:"",
        },
        rules:{
          returnMoney:[
          {required: true, message: "请输入退款金额", trigger: "blur" }
        ],
        }
    }
  },
  mounted(){
    this._orderRecord()
     if(!!this.$refs.table){
			window.onresize = () => {
				return (() => {
					this.maxTableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 76 - 40;
				})()
			}
    }
    
  },
   computed:{
        	...mapGetters(
            	['isCaptal']
        	),
    	},
  methods: {
      addRemark(val,row){
        let params = {}
        params.type = row.type
        params.id = row.id
        params.cardId = row.iccidMark
        params.remark = val
        params.payStatus = 1
        add4remark(params).then((res)=>{
          this._orderRecord()
        })
      },
      handleSizeChange(val){
          this.pageSize = val
          this._orderRecord()
      },
      handleCurrentChange(val){
          this.pageNo = val
          this._orderRecord()
      },
      _orderRecord(){
        let params = {};
        params.pageNo = this.pageNo
        params.pageSize = this.pageSize
        if(!!this.previousOrdersForm.orderNumber){
            params.orderNumber = this.previousOrdersForm.orderNumber;
        }
        if(!!this.previousOrdersForm.iccidMark){
          params.cardId = this.previousOrdersForm.iccidMark;
        }
         if(!!this.previousOrdersForm.shortIccid){
          params.shortIccid = this.previousOrdersForm.shortIccid;
        }
        orderRecord(params).then((res) => {
          this.pageNo = res.pageNo
          this.pageSize = res.pageSize
          this.total = res.total
          this.tableData = res.rows
          this.maxTableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 76 - 40;
        }).catch(()=>{

        });
      },
      onSearch(){
        this._orderRecord();
      },
      handleTuiKuan(orderNumber,orderMoney){
      this.dialogRefundVisible = true
      this.refundForm.orderNumber = orderNumber
      this.orderMoney = orderMoney
      this.refundForm.returnMoney = ''
      this.refundForm.returnReson = ''
    },

    sureRefund(){
      let returnMoney = this.refundForm.returnMoney;
      console.log("returnMoney : ",returnMoney);
      if((!returnMoney && returnMoney !=0 ) || !this.refundForm.returnReson){
        this.$alert('请填写退款金额或退款理由', '提示', {
          confirmButtonText: '确定',
        });
      return
      }

      if(parseFloat(this.refundForm.returnMoney) > parseFloat(this.orderMoney)){
        this.$alert('退款金额不能大于订单金额', '提示', {
          confirmButtonText: '确定',
          });
        return
      }
      this.isDisable = true
      let msgTip = "登记退款成功";
      if(parseFloat(this.refundForm.returnMoney) < parseFloat(this.orderMoney)){
        msgTip = "登记退款成功(部分退款,请手动删除剩余套餐)";
      }
      refundMoney(this.refundForm).then(res=>{
        this.isDisable = false
        if(res.system_result_key == 0){
            this.$message({
              showClose: true,
              message: msgTip,
              type: 'success'
            })
            this.dialogRefundVisible = false
            this._orderRecord()
          }
        }).catch(()=>{
          this.isDisable = false
      })
    }
      
  }
};
</script>

<style>
</style>
